import { render } from "./InvoicePdf.vue?vue&type=template&id=1bfe29eb"
import script from "./InvoicePdf.vue?vue&type=script&lang=js"
export * from "./InvoicePdf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__